import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IonItemSliding } from '@ionic/angular';

export type SwipeActionType = 'edit' | 'delete';

@Component({
  selector: 'getm-swipe-actions',
  templateUrl: './swipe-actions.component.html',
  styleUrls: ['./swipe-actions.component.scss'],
})
export class SwipeActionsComponent {

  @ViewChild('itemSliding', { static: true }) itemSliding!: IonItemSliding;

  @Input() actions: SwipeActionType[] = ['edit', 'delete'];

  @Output() editClick = new EventEmitter<void>();
  @Output() deleteClick = new EventEmitter<void>();

  public async openOptions(): Promise<void> {
    await this.itemSliding.open('end');
  }

  public async onEditClick(): Promise<void> {
    await this.itemSliding.closeOpened();
    this.editClick.emit();
  }

  public async onDeleteClick(): Promise<void> {
    await this.itemSliding.closeOpened();
    this.deleteClick.emit();
  }
}
